import { z } from "zod";

export const OrgSchema = z.object({
  id: z.string().uuid(),
  name: z.string().min(1),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type Org = z.infer<typeof OrgSchema>;

export const OrgMemberRoleEnum = z.enum(["owner", "admin", "member"]);

export const OrgMemberSchema = z.object({
  id: z.string().uuid(),
  orgId: z.string().uuid(),
  userId: z.string().uuid(),
  role: OrgMemberRoleEnum,
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type OrgMember = z.infer<typeof OrgMemberSchema>;
